import React from 'react';
import { STACK_ALIGN, STACK_DIRECTION, STACK_GAP, StackView } from "../../StackView";
import { Icon } from "../../Icon";
import { Text } from "../../Text";
import { LinkButton } from "../../controls";
function NotificationActions(_a) {
    var items = _a.items;
    if (!items || !items.length) {
        return null;
    }
    return (React.createElement(StackView, { direction: STACK_DIRECTION.row, align: STACK_ALIGN.center, gap: STACK_GAP.m }, items.map(function (_a, idx) {
        var text = _a.text, testId = _a.testId, icon = _a.icon, handler = _a.handler;
        return (React.createElement(LinkButton, { key: "" + (testId || '') + text + idx, compact: true, onClick: handler, iconBefore: icon, "data-selector-id": testId }, text));
    })));
}
export function createNotification(config) {
    return (React.createElement(StackView, { direction: STACK_DIRECTION.row, align: STACK_ALIGN.center, gap: STACK_GAP.m },
        React.createElement(StackView, { direction: STACK_DIRECTION.row, align: STACK_ALIGN.center, gap: STACK_GAP.s },
            !!config.icon && React.createElement(Icon, { src: config.icon }),
            typeof config.content === 'string' ? (React.createElement(Text, null, config.content)) : (config.content)),
        React.createElement(NotificationActions, { items: config.actions })));
}
//# sourceMappingURL=createNotification.js.map